export default {"src":"/polygon/_next/static/media/web.c3c39722.svg","height":160,"width":161};